/**
 * Makes all properties in T optional, and recursively does the same for all nested objects.
 * Unlike the built-in Partial type, this works for nested objects.
 *
 * @template T - The type to make deeply partial
 */
export type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

export interface CommonError {
  code: string;
  message: string;
}

export interface CallbackAction {
  onSuccess?: () => void;
}

export enum ViewMode {
  RECENT = 'recent',
  ALL = 'all',
}

export enum DisplayMode {
  GRID = 'grid',
  LIST = 'list',
}
export interface BaseEntityWebSocketResponse<T> {
  id?: string;
  data: T;
  by?: string;
  group?: string;
  occurredAt: string;
}
